var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrodo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.57 11.933V6.466L16.107 1 6.644 6.466v5.467l9.463-5.467 9.463 5.467zm-9.463 5.466-9.463-5.467v5.466l9.463 5.465L25.57 17.4v-5.467l-9.463 5.466zM7.73 20.74l8.377 4.555 8.376-4.555 4.731 2.733-8.376 4.555-4.73 2.733-4.732-2.732L3 23.473 7.73 20.74z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrodo);
export default __webpack_public_path__ + "static/media/CRODO.344500e7bcd3db7ebd04901d24840e31.svg";
export { ForwardRef as ReactComponent };